/**
 * Centralized broadcast channel names for cross-tab synchronization.
 *
 * This file contains all the broadcast channel names used throughout the application
 * to ensure consistency and avoid naming conflicts.
 */
export const BROADCAST_CHANNELS = {
	/**
	 * Channel for synchronizing authentication state across tabs.
	 * Used for login/logout events.
	 */
	AUTH_SYNC: 'auth_sync',

	/**
	 * Channel for synchronizing wishlist changes across tabs.
	 * Used for wishlist add/remove operations.
	 */
	WISHLIST_SYNC: 'wishlist_sync',

	/**
	 * Channel for synchronizing user preferences across tabs.
	 * Used for preferences cookie updates.
	 */
	PREFERENCES_SYNC: 'preferences_channel',

	/**
	 * Channel for synchronizing ad campaign data across tabs.
	 * Used for campaign tracking and attribution.
	 */
	AD_CAMPAIGN_SYNC: 'ad_campaign_channel'
} as const;

/**
 * Type for broadcast channel names
 */
export type BroadcastChannelName =
	(typeof BROADCAST_CHANNELS)[keyof typeof BROADCAST_CHANNELS];
